import { render, staticRenderFns } from "./AdminSwatVersionList.vue?vue&type=template&id=4f54ccbe&"
import script from "./AdminSwatVersionList.vue?vue&type=script&lang=js&"
export * from "./AdminSwatVersionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports